var projects: { image_location: { asset: string; description?: string }[], description: string, id?: number }[] = [
    {
        image_location: [{ asset: "southwest.jpg" }],
        description: "South West Middle School Chiller Plant"
    },
    {
        image_location: [{ asset: 'meadowlane.jpg' }],
        description: "Meadowlane Primary Elementary Infrastructure Renewal"
    },
    {
        image_location: [{ asset: 'efsc.jpg' }],
        description: "Eastern Florida State College Student Union"
    },
    {
        image_location: [{ asset: 'panel-collage/panel-1.jpg' }, { asset: 'panel-collage/panel-2.jpg' }, { asset: 'panel-collage/panel-3.jpg' }, { asset: 'panel-collage/panel-4.jpg' }, { asset: 'panel-collage/panel-5.jpg' }],
        description: "Access Control System Upgrade"
    },

];

export function initializeProjects() {
    for (let i in projects) {
        projects[i].id = parseInt(i) + 1;
    }
}

export function getProject(id: number) {
    return projects.find(p => p.id === id);
}
export function getProjects() {
    return projects;
}